module.exports = __webpack_public_path__ + "media/images/guide-4-56608edefe11f7bc68091e84dff07ced.png";